import gql from 'graphql-tag';
import { parseToMutationRequest } from 'utils/utils';

export default data => {
  const dataModify = parseToMutationRequest(data, ['type', 'index']);
  const saveCostCenterMap = `saveCostCenterMap(input: ${dataModify})`;
  return gql`
  mutation {
    ${saveCostCenterMap} {
      id
    }
  }
`;
};
